// Libraries
import {
    showLoader,
    hideLoader,
} from '../../redux/common/loader/loader.actions';
import filter from '../../static/images/filter.png';
import { isValuesEmpty } from '../../utils/helperMethods';
import validate from './validator';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import styled from 'styled-components';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { components } from 'react-select';
import { MultiSelect } from "react-multi-select-component";

// Actions

// Assets

// Validator
import { FormElems, Overlay, DatePicker, TimePicker, TermPicker, CustomSelect } from '..';

// Components

// Styles
import './tableFilter.scss';
import { MAX_FILTERS_WITHOUT_SCROLL } from 'utils/constants/commonValues';

const renderDateInput = field => <DatePicker {...field} />;

const renderTimeInput = field => <TimePicker {...field} />;


const FormField = props => {
    const {
        field,
        startDate,
        endDate,
        focusedInput,
        setStartDate,
        setEndDate,
        setFocusedInput,
        startTime,
        endTime,
        setStarTime,
        setEndTime,
        maximumNights
    } = props;
    if (field.fieldType === 'date') {
        return (
            <Field
                name={field.name}
                {...field.props}
                startDateId="tableFilterStartDate"
                endDateId="tableFilterEndDate"
                startDate={startDate}
                endDate={endDate}
                showDefaultInputIcon={false}
                focusedInput={focusedInput}
                onSetStartDate={startDate => {
                    setStartDate(startDate);
                }}
                onSetEndDate={endDate => {
                    setEndDate(endDate);
                }}
                onFocusedInput={focusedInput => {
                    setFocusedInput(focusedInput);
                }}
                component={renderDateInput}
                maximumNights={maximumNights}
            />
        );
    } else if (field.fieldType === 'select') {
        return (
            <Field
                name={field.name}
                {...field.props}
                component={FormElems.Select}
            />
        );
    } else if (field.fieldType === 'radio') {
        return (
            <Field
                name={field.name}
                {...field.props}
                component={FormElems.Radio}
            />
        );
    } else if (field.fieldType === 'month-picker') {
        return (
            <Field name={field.name} {...field.props} component={TermPicker} />
        );
    } else if (field.fieldType === 'checkbox') {
        return (
            <Field
                name={field.name}
                {...field.props}
                component={FormElems.Checkbox}
            />
        );
    } else if (field.fieldType === 'time') {
        return (
            <Field
                name={field.name}
                {...field.props}
                startTime={startTime}
                endTime={endTime}
                setStarTime={setStarTime}
                setEndTime={setEndTime}
                component={renderTimeInput}
            />
        );
    } else if (field.fieldType === 'parallel-input') {
        return (
            <div className="parallelInp">
                <div className="field1">
                    <Field
                        name={field.fieldA.name}
                        {...field.fieldA.props}
                        component={FormElems.Input}
                    />
                </div>

                <div className="field2">
                    <Field
                        name={field.fieldB.name}
                        {...field.fieldB.props}
                        component={FormElems.Input}
                    />
                </div>
            </div>
        );
    } else if (field.fieldType === 'search-select') {
        return (
            <Field
                name={field.name}
                {...field.props}
                component={FormElems.SearchSelect}
            />
        );
    } else if (field.fieldType === 'dynamic-select') {
        return (
            <Field
                name={field.name}
                {...field.props}
                component={FormElems.DynamicSelect}
            />
        );
    } else if(field.fieldType === 'multi-select') {
       return (
           <Field
               name={field.name}
               {...field.props}
               component={FormElems.Multiselect}
           />
       )
    } else if(field.fieldType === 'multi-select-with-search') {
        return (
            <Field
                name={field.name}
                {...field.props}
                component={FormElems.MultiSelectWithSearch}
            />
        )
    } else if(field.fieldType === 'parallel-multi-select') {
        return (
            <div className="parallel-multi-select">
                <div className="field1">
                    <Field
                        name={field.fieldA.name}
                        {...field.fieldA.props}
                        component={FormElems.Multiselect}
                    />
                </div>

                <div className="field2">
                    <Field
                        name={field.fieldB.name}
                        {...field.fieldB.props}
                        displayLabel={true}
                        component={FormElems.Multiselect}
                    />
                </div>
            </div>
        );
    }
    return (
        <Field name={field.name} {...field.props} component={FormElems.Input} />
    );
};

FormField.propTypes = {
    endDate: PropTypes.string,
    field: PropTypes.object,
    focusedInput: PropTypes.string,
    setEndDate: PropTypes.func,
    setFocusedInput: PropTypes.func,
    setStartDate: PropTypes.func,
    startDate: PropTypes.string,
    startTime: PropTypes.string,
    endTime: PropTypes.string,
    setStarTime: PropTypes.func,
    setEndTime: PropTypes.func,
};

const ErrorWrapper = styled.div`
    color: #f00;
    display: block;
    font-size: 12px;
    margin: 8px 0;
`;
const TableFilter = ({
    fieldsList,
    handleSubmit,
    showOverlay,
    onSubmit,
    customFilterClass,
    pristine,
    reset,
    onReset,
    submitting,
    formData,
    dirty,
    invalid,
    change,
    isResetFilterOnLoad,
    maximumNights,
}) => {
    const dateField = fieldsList.find(field => field.fieldType === 'date');
    const dateProps = dateField?.props || {};
    const startDateDefault = dateProps.startDate || null;
    const endDateDefault = dateProps.endDate || null;
    const notResetDate = dateProps.notResetDate;

    const [showFilter, setShowFilter] = useState(false);
    const [startDate, setStartDate] = useState(startDateDefault);
    const [endDate, setEndDate] = useState(endDateDefault);
    const [focusedInput, setFocusedInput] = useState(null);

    // Start Time States
    const [startTime, setStarTime] = useState(null);
    const [endTime, setEndTime] = useState(null);

    const closeFilter = () => {
        // If user clicks outside the element, hide it!
        setShowFilter(false);
    };

    useEffect(() => {
        if (endDateDefault && startDateDefault) {
            const defaultDate = {
                createdOn: {
                    startDate: startDateDefault,
                    endDate: endDateDefault,
                },
            };
            change('createdOn', defaultDate.createdOn);
            onSubmit(defaultDate);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [endDateDefault, startDateDefault]);

    const handleFilterClick = () => {
        setShowFilter(prevState => !prevState);
    };

    const handleFormSubmit = values => {
        console.log(values, "VALUES_VALUES");
        onSubmit(values);
        closeFilter();
    };

    const resetFilter = () => {
        reset();
        if (endDateDefault && startDateDefault && notResetDate) {
            const defaultDate = {
                createdOn: {
                    startDate: startDateDefault,
                    endDate: endDateDefault,
                },
            };
            change('createdOn', defaultDate.createdOn);
            setStartDate(startDateDefault);
            setEndDate(endDateDefault);
            onReset &&
                onReset({
                    createdOn: defaultDate.createdOn,
                });
        } else {
            onReset && onReset({});
        }
    };

    useEffect(() => {
        if (isResetFilterOnLoad) {
            resetFilter();
        }
        return () => {
            resetFilter();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isResetFilterOnLoad]);

    const handleReset = () => {
        if (!notResetDate) {
            setStartDate(null);
            setEndDate(null);
            setStarTime(null);
            setEndTime(null);
        }
        resetFilter();
        closeFilter();
    };

    return (
        <div className="tableFilterWrap">
            <button
                className="filterBtn"
                id="filter-button"
                onClick={handleFilterClick}
            >
                <img src={filter} alt="Close Icon" />
            </button>
            {showFilter ? (
                <>
                    {showOverlay ? (
                        <Overlay closeFilter={closeFilter} isTransparent />
                    ) : null}
                    <div className={`tableFilter ${customFilterClass}`}>
                        <form
                            className="filter-form"
                            onSubmit={handleSubmit(handleFormSubmit)}
                        >
                            <div
                                className={`filter-fields ${fieldsList.length > MAX_FILTERS_WITHOUT_SCROLL ? 'scrollable' : ''}`}
                            >
                                {fieldsList.map(field => (
                                    <div className="form-field" key={field.label}>
                                        <p data-field_type={field.fieldType} className="label filterTitle">
                                            {field.label}
                                        </p>
                                        <FormField
                                            field={field}
                                            startDate={startDate}
                                            endDate={endDate}
                                            startTime={startTime}
                                            endTime={endTime}
                                            setStarTime={setStarTime}
                                            setEndTime={setEndTime}
                                            focusedInput={focusedInput}
                                            setStartDate={setStartDate}
                                            setEndDate={setEndDate}
                                            setFocusedInput={setFocusedInput}
                                            maximumNights={maximumNights}
                                        />
                                        {field.fieldType === 'date' &&
                                            dirty &&
                                            formData?.syncErrors && (
                                                <ErrorWrapper className="error-message">
                                                    {formData.syncErrors.form}
                                                </ErrorWrapper>
                                            )}
                                    </div>
                                ))}
                            </div>

                            <div className="form-field actions">
                                <FormElems.Button
                                    buttonType="secondary"
                                    text="RESET"
                                    type="button"
                                    handleClick={handleReset}
                                    isDisable={submitting}
                                />
                                <FormElems.Button
                                    buttonType="primary"
                                    text="APPLY"
                                    isDisable={
                                        (formData &&
                                            isValuesEmpty(formData.values)) ||
                                        pristine ||
                                        invalid
                                    }
                                />
                            </div>
                        </form>
                    </div>
                </>
            ) : null}
        </div>
    );
};

TableFilter.propTypes = {
    customFilterClass: PropTypes.string,
    fieldsList: PropTypes.array,
    handleSubmit: PropTypes.func,
    onReset: PropTypes.func,
    onSubmit: PropTypes.func,
    change: PropTypes.func,
    showOverlay: PropTypes.bool,
    pristine: PropTypes.bool,
    reset: PropTypes.func,
    submitting: PropTypes.bool,
    dirty: PropTypes.bool,
    invalid: PropTypes.bool,
    formData: PropTypes.object,
    isResetFilterOnLoad: PropTypes.bool,
};

const mapStateToProps = ({ auth, form }) => ({
    auth,
    formData: form['table-filter'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            hideLoader,
            showLoader,
        },
        dispatch
    ),
});

export default compose(
    reduxForm({
        form: 'table-filter',
        destroyOnUnmount: false,
        enableReinitialize: true,
        keepDirtyOnReinitialize: true,
        initialValues: {
            rangeType: 'updated_on',
        },
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(TableFilter);
